module.exports = __webpack_public_path__ + "img/yiyao_duotang.232771a1.png";